import { useNavigation } from '@react-navigation/native'
import Onboarding from 'react-native-onboarding-swiper'
import { StyleSheet, Image } from 'react-native'

const OnboardingScreens = () => {
    const navigation = useNavigation()

    return (
        <Onboarding
            pages={[
                {
                    backgroundColor: '#fff',
                    image: <Image style={styles.logo} source={require('../assets/logos/ZHOnly.png')} />,
                    title: 'Hunt undead homes.',
                    subtitle: 'Get paid.',
                },
                {
                    backgroundColor: '#6c387a',
                    image: <Image source={require('../assets/homeslide.png')} />,

                    title: 'Spot an ugly, dilapidated home in your neighborhood',
                    subtitle: '',
                },
                {
                    backgroundColor: '#fff',
                    image: <Image source={require('../assets/picsslide.png')} />,

                    title: 'Snap a pic and tag its horrendous conditions and features',
                    subtitle: '',
                },
                {
                    backgroundColor: '#397D2E',
                    image: <Image style={styles.logo} source={require('../assets/rewardsslide.png')} />,

                    title: 'Choose from several cash rewards',
                    subtitle: '',
                },
            ]}
            onDone={() => navigation.navigate('Signup')}
            onSkip={() => navigation.navigate('Signup')}
            containerStyles={styles.container}
        />
    )
}

export default OnboardingScreens

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundImage: require('../assets/homeslide.png'),
    },
    logo: {
        width: '95%',
        height: undefined,
        aspectRatio: 205 / 152,
    },
    slide: {
        width: '100%',
    },
})
